<template>
  <v-card class="overview-profile" flat>
    <div class="history-content">
      <div class="flex-row-wrap">
        <div>
          <label>Bevorzugter Fuß</label>
          {{ userData.foot }}
        </div>
        <div>
          <label>Spielertyp</label>
          <span v-for="(type, i) in userData.player_type" :key="i">{{ type }}</span>
        </div>
        <div>
          <label>Aktuell vereinslos</label>
          {{ userData.no_team ? 'Nein' : 'Ja' }}
        </div>
        <div>
          <label>Sprachen</label>
          <span v-for="(language, i) in userData.languages" :key="i">
            {{ language }}
            <span v-if="i !== userData.languages.length - 1"></span>
          </span>
        </div>
      </div>
    </div>
    <v-list>
      <v-list-group no-action>
        <template v-slot:activator>
          <h3>Mehr Infos</h3>
        </template>

        <div>
          <div class="history-content">
            <div class="flex-row-wrap">
              <div>
                <label>Geburtsort</label>
                {{ userData.birthplace }}
              </div>
              <div>
                <label>Größte Erfolge</label>
                {{ userData.successes }}
              </div>
              <div>
                <label>Bundesland</label>
                {{ userData.living_in_state }}
              </div>
              <div>
                <label>Auszeichnungen</label>
                {{ userData.prices }}
              </div>
            </div>
          </div>
        </div>
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'profile-user-bio',

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
